<template>
    <div class="bg-black banner-section">
        <div class="overlay"></div>
        <video class="video" autoplay="autoplay" playsinline id="banner-video" muted="muted" loop="loop">
            <source src="https://storage.googleapis.com/activamedia/wsc-waterkids-c-02.mp4" type="video/mp4">
        </video>
        <div class="container relative z-10 h-full mx-auto show-on-scroll">
            <div>
                <nav class="flex flex-wrap items-center justify-between px-6 py-4 lg:pt-10">
                    <div class="flex-1 lg:order-2">
                        <router-link to="/"><img src="/images/logo.png" alt="Aik Hock Tyre & Battery Services" class="h-12 lg:h-24 lg:mx-auto"></router-link>
                    </div>
                    <div class="flex-none mr-6 lg:order-1 lg:flex-1">
                        <div class="flex items-center text-lg text-white">
                            <a href="tel:88957955" class="cta-btn">
                                <img src="/images/call-us-icon.png" alt="Call Us" class="inline-block h-10 md:mr-2 lg:h-12"> <span class="hidden md:inline-block">8895 7955</span>
                            </a>
                        </div>
                    </div>
                    <div class="flex-none lg:order-3 lg:flex-1">
                        <div class="flex items-center text-lg text-white lg:justify-end">
                            <a href="https://wa.me/6588957955" target="_blank" class="wa-btn">
                                <img src="/images/whatsapp-icon.png" alt="Whats App" class="inline-block h-10 align-top md:mr-2 lg:h-12">
                                <div class="hidden leading-none md:inline-block md:mt-1">
                                    <div class="mb-1 text-xs">WhatsApp</div>
                                    <div>8895 7955</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </nav>
            </div>
            <div class="flex flex-col justify-end h-full pb-64 text-center banner-text lg:pb-32 md:pb-48 lg:pb-64" data-aos="fade-up" data-aos-easing="ease-out-back">
                <div class="w-full mb-3 text-6xl leading-none text-white title-text">
                    Toddlers & Babies <br>Swim School
                </div>
                <a href="#form-section" class="self-center block px-16 py-3 m-2 mx-3 font-semibold text-white bg-transparent border border-white rounded-full hover:border-gray-500 hover:text-gray-500 hover:border-transparent md:inline-block">
                    Start Today
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    // import VueAos from 'vue-aos'

    export default {
        name: 'MainBanner',
        components: {
            // VueAos
        },
        props: {
            msg: String
        },
        data() {
            return {
                isOpen: false
            }
        },
        methods: {
            openNav() {
                console.log('testss')
                return 'test'
            },
            // openNav() {
                // $("#nav").slideToggle()
            // }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .banner-section {
        position: relative;
        background-color: black;
        height: 100vh;
        width: 100%;
        overflow: hidden;

        .title-text {
            font-size: 34px
        }
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: black;
        opacity: 0.7;
        z-index: 1;
    }

    video {
        position: absolute;
        top: 50%;
        left: 50%;
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        z-index: 0;
        -ms-transform: translateX(-50%) translateY(-50%);
        -moz-transform: translateX(-50%) translateY(-50%);
        -webkit-transform: translateX(-50%) translateY(-50%);
        transform: translateX(-50%) translateY(-50%);
        max-width: unset;
    }

    /* Landscape */
    @media only screen 
        and (min-device-width: 375px) 
        and (max-device-width: 812px) 
        and (-webkit-min-device-pixel-ratio: 3)
        and (orientation: landscape) { 
            .banner-text {
                padding-bottom: 100px;
            }
    }

    @media (min-width: 425px) {
        .banner-section {

            .title-text {
                font-size: 44px
            }
        }
    }

    @media (min-width: 768px) {
        .banner-section {

            .title-text {
                font-size: 64px
            }
        }
    }

    @media (min-width: 1199px) {
        .banner-section {

            .title-text {
                font-size: 94px
            }
        }
    }
</style>
